import { Card, Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import logoAtonito from '../../assets/atonito/logoAtonito.png';
import logoAtonito2 from '../../assets/atonito/LogoAtonito2.png';
import botellaAtonito from '../../assets/atonito/botellaAtonito.png'
import citricos from '../../assets/atonito/citricos.jpg'
import atonitoJuntadas1 from '../../assets/atonito/Atonito-juntadas1.jpg'
import atonitoJuntadas2 from '../../assets/atonito/Atonito-juntadas2.jpg'
import atonitoJuntadas3 from '../../assets/atonito/Atonito-juntadas3.jpg'
import instagram from '../../assets/logos/instagram.png'
import atonic from '../../assets/cocktails/atonic.jpg'
import garibaldi from '../../assets/cocktails/Garibaldi.jpg'
import '../Atonito/MainAtonito.css'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import flagEsp from '../../assets/logos/espana.png';
import flagUsa from '../../assets/logos/estados-unidos.png';
import flagChina from '../../assets/logos/china.png'
import logo from '../../assets/aba/logo-aba.png'

const container = {
    backgroundColor: '#27254A', 
    color: 'white'
}

const texts = {
    alignContent: 'center',
    textAlign: 'center',
    fontSize: '25px'
}

const textsRedes = {
    alignContent: 'center',
    textAlign: 'center',
    fontSize: '15px'
}

const styleNav = {
    textAlign: 'center'
};

function MainAtonito() {

    const { i18n, t } = useTranslation();

    return (
        <Container fluid style={container}>
            <Row>
                <Navbar expand="lg" className="bg-body-white">
                    <Container>
                        <Navbar.Brand href="/">
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto" style={styleNav}>
                            <Navbar.Brand onClick={() => {i18n.changeLanguage('es')}} style={{color: 'white'}}>
                                    <img
                                        alt=""
                                        src={flagEsp}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ESP
                                    </Navbar.Brand> 
                                    <Navbar.Brand onClick={() => {i18n.changeLanguage('en')}} style={{color: 'white'}}>
                                    <img
                                        alt=""
                                        src={flagUsa}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ENG
                                    </Navbar.Brand> 
                                    <Navbar.Brand onClick={() => {i18n.changeLanguage('zh')}} style={{color: 'white'}}>
                                    <img
                                        alt=""
                                        src={flagChina}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ZH
                                    </Navbar.Brand> 
                            </Nav>

                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </Row>
            <Row>
                <Col xs={1} md={1}></Col>
                <Col md={10}>
                    <img
                        src={logoAtonito}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={1} md={1}></Col>
                <Col style={textsRedes} md={4} xs={8}> {t('FollowUsOnOurNetworks')}</Col>
                <Col md={12} xs={8} style={{height: '30px', width:'60px'}}>
                    <Link to='https://www.instagram.com/atonito.ar/'>
                        <img
                            src={instagram}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Aba logo"
                        />
                    </Link>
                </Col>
                <Col md={4} style={{height: '30px', width:'60px'}} className="d-none d-lg-block"><h5>@atonito.ar</h5> </Col>
            </Row>
            <hr/>
            <Row style={{ marginTop: '40px' }}>
                <Col xs={1} md={1}></Col>
                <Col style={texts} md={5} xs={12}>
                    <img
                        src={botellaAtonito}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col style={{color:'white'}} md={5} xs={12}>
                    <Row></Row>
                    <Row>
                        <Col style={{marginTop: '10px'}} xs={6} md={12}>
                            <h2>{t('atonitoTitle')}</h2>
                            <p>{t('atonitoText1')}</p>
                        </Col>
                        {/* Version Mobile (ACTIVAR MAÑANA VIERNES) */}
                        <Col style={{ alignSelf: 'center' }} xs={6} md={12} className="d-md-none">
                            <img
                                src={logoAtonito2}
                                width="100%"
                                height="60%"
                                className="d-inline-block align-top"
                                alt="Pais"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ marginTop: '40px' }} xs={6} md={12} className="d-none d-lg-block">
                            <img
                                src={logoAtonito2}
                                width="100%"
                                height="100%"
                                className="d-inline-block align-top"
                                alt="Pais"
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <Row style={{ marginTop: '30px', marginBottom: '50px'}}>
                <Col xs={1} md={1}></Col>
                <Col md={8} xs={12}>
                    <img
                        src={citricos}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{ borderRadius: '50px' }}
                    />
                    {/* <h2>Cítricos Entrerrianos</h2>
                    <p>Entre los que se destacan la naranja , mandarina , pomelo y limón , 
                       son una de las claves para lograr el sabor tan particular de nuestro bitter y poder dejarte completamente ATÓNITO </p> */}
                </Col>
                <Col md={5} className="texto-flotante d-none d-lg-block">
                    <h2>{t('atonitoSection1Title')}</h2>
                    <p>{t('atonitoSection1Text')}</p>
                </Col>
                {/* Version Mobile */}
                <Col md={5} className="texto-flotante-mobile d-md-none">
                    <h5>{t('atonitoSection1Title')}</h5>
                    <p>{t('atonitoSection1Text')}</p>
                </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <hr/>
            <Row style={{ marginTop: '60px' }}>
                <Col xs={1} md={1}></Col>
                <Row>
                    <Col md={4} xs={12}>
                        <img
                            src={atonitoJuntadas1}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Pais"
                            style={{ borderRadius: '50px' }}
                        />
                    </Col>
                    <Col md={4} xs={12} className="d-none d-lg-block">
                        <img
                            src={atonitoJuntadas2}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Pais"
                            style={{ borderRadius: '50px' }}
                        />
                    </Col>
                    <Col md={4} xs={12} className="d-none d-lg-block">
                        <img
                            src={atonitoJuntadas3}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Pais"
                            style={{ borderRadius: '50px' }}
                        />
                    </Col>
                    <Col md={5} className="texto-flotante-2 d-none d-lg-block">
                        <p>{t('atonitoSection2Text')}</p>
                    </Col>
                </Row>
                <Col md={5} xs={12} className="texto-flotante-mobile-2 d-md-none">
                        <p>{t('atonitoSection2Text')}</p>
                    </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <hr/>
            <Row style={ {textAlign: 'center', padding: '5px'}}>
                <Col xs={1} md={1}></Col>
                <Col style={texts} md={12}>{t('cocktails')}</Col>
                <Col xs={12} md={4}>
                    <Card style={{ width: '100%' }}>
                        <Card.Img variant="top" src={atonic} />
                        <Card.Body>
                            <Card.Title>{t('Atonik')}</Card.Title>
                                <Card.Text>
                                    {t('ingredientsAtonik')}
                                </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={4}>
                    <Card style={{ width: '100%' }}>
                    <Card.Img variant="top" src={garibaldi} />
                    <Card.Body>
                        <Card.Title>{t('garibaldi')}</Card.Title>
                            <Card.Text>
                                {t('ingredientsGaribaldi')}
                            </Card.Text>
                    </Card.Body>
                    </Card>
                </Col>
                {/* <Col xs={12} md={4}>
                    <Card style={{ width: '100%' }}>
                    <Card.Img variant="top" src={atonitoJuntadas3} />
                    <Card.Body>
                        <Card.Title>Atonic</Card.Title>
                            <Card.Text>
                            Atónito, Tónica, Naranja
                            </Card.Text>
                            {/* <Button variant="primary" onClick={handleShowCoctail2} >Receta Completa</Button> 
                    </Card.Body>
                    </Card>
                </Col> */}
            </Row>
        </Container>
    );
}

export default MainAtonito;